import type { ApExamSession } from '@/store/modules/apexam/apexam'

const AP_EXAM_SESSION_STORAGE_KEY = 'edgewise:apexam:current-session'
const AP_EXAM_SESSION_STORAGE_VERSION = 1

type CachedApExamSessionPayload = {
    version: number
    savedAt: number
    session: ApExamSession
}

const getStorage = () => {
    
    return window.sessionStorage
}

const isValidApExamSession = (value: any): value is ApExamSession => {
    return Boolean(
        value &&
        typeof value.examId === 'string' &&
        Array.isArray(value.questions)
    )
}

export const saveApExamSessionSnapshot = (session: ApExamSession | null) => {
    const storage = getStorage()
    if (!storage) return

    if (!session || !Array.isArray(session.questions) || !session.questions.length) {
        storage.removeItem(AP_EXAM_SESSION_STORAGE_KEY)
        return
    }

    const payload: CachedApExamSessionPayload = {
        version: AP_EXAM_SESSION_STORAGE_VERSION,
        savedAt: Date.now(),
        session
    }

    storage.setItem(AP_EXAM_SESSION_STORAGE_KEY, JSON.stringify(payload))
}

export const clearApExamSessionSnapshot = () => {
    const storage = getStorage()
    if (!storage) return
    storage.removeItem(AP_EXAM_SESSION_STORAGE_KEY)
}

export const getApExamSessionSnapshot = (examId?: string) => {
    const storage = getStorage()
    if (!storage) return null

    const raw = storage.getItem(AP_EXAM_SESSION_STORAGE_KEY)
    if (!raw) return null

    try {
        const payload = JSON.parse(raw) as CachedApExamSessionPayload
        const session = payload?.session

        if (payload?.version !== AP_EXAM_SESSION_STORAGE_VERSION || !isValidApExamSession(session)) {
            storage.removeItem(AP_EXAM_SESSION_STORAGE_KEY)
            return null
        }

        if (examId && session.examId !== examId) {
            return null
        }

        return session
    } catch {
        storage.removeItem(AP_EXAM_SESSION_STORAGE_KEY)
        return null
    }
}
